import {
  type SendAlertResolvedField,
  type SendAlertScreenResolved,
  SEND_ALERT_FEATURE_ID,
  ALERT_SUCCESS_MESSAGE,
  buildStakeholderSelectOptions,
} from "./model";
import { COUNTRY_OPTIONS, DELIVERY_OPTIONS } from "./form";

/**
 * Pure “resolver” for the Send Alert feature: labels, field metadata, and static option lists.
 * Presentation layers (web + native) map `fields` / `sections` to platform controls and call
 * shared helpers (`validateSendAlertForm`, `buildBuxusSendAlertDto`, county list helpers).
 */
export function resolveSendAlertScreen(): SendAlertScreenResolved {
  const fields: SendAlertResolvedField[] = [
    {
      kind: "select",
      id: "stakeholderType",
      label: "Stakeholder Type",
      /** Web: empty native select + floating label; native picker / other clients may still use as blank row. */
      placeholder: "",
      required: true,
    },
    {
      kind: "select",
      id: "country",
      label: "Country",
      placeholder: "",
      required: true,
    },
    {
      kind: "select",
      id: "state",
      label: "State / Province",
      placeholder: "",
      required: true,
    },
    {
      kind: "select",
      id: "county",
      label: "County",
      placeholder: "",
      required: true,
    },
    /** Kept for `buildBuxusSendAlertDto` / future UI — not listed in `sections` while hidden. */
    {
      kind: "text",
      id: "title",
      label: "Title",
      placeholder: "Optional subject line",
      required: false,
    },
    {
      kind: "textarea",
      id: "message",
      label: "Message",
      placeholder: "Message",
      required: true,
      defaultValue: "TEST ALERT (please disregard if received)",
    },
    {
      kind: "select",
      id: "deliveryType",
      label: "Delivery Type",
      placeholder: "",
      required: true,
    },
  ];

  return {
    featureId: SEND_ALERT_FEATURE_ID,
    title: "Send Alert",
    stakeholderOptions: buildStakeholderSelectOptions(),
    countryOptions: COUNTRY_OPTIONS,
    deliveryOptions: DELIVERY_OPTIONS,
    sections: [
      {
        heading: "Recipients",
        fieldIds: ["stakeholderType", "country", "state", "county"],
      },
      {
        heading: "Information",
        fieldIds: ["message", "deliveryType"],
      },
    ],
    fields,
    strings: {
      continueCta: "Continue",
      sendCta: "Send Alert",
      previewHeading: "Preview summary",
      requiredBanner: "Please fill out the required fields below.",
      successMessage: ALERT_SUCCESS_MESSAGE,
    },
  };
}
